import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import _isEmpty from 'lodash/isEmpty'

import { useAppDispatch, useAppSelector } from 'app/hooks'
import { StyledFadeInWrapper } from 'components/Layout/CommonLayout/styles'
import { homeJobSelector } from 'features/home/selectors'
import { JobPageContext } from 'features/jobs/JobPageContext'
import { JobInfo } from 'features/jobs/components'
import { fetchJobInfoActions, fetchJobInfoThunk } from 'features/jobs/slice'
import { JobBlockContainer, StyledJobHeader } from 'features/jobs/styles'
import { jobPageMessages } from 'features/jobs/messages'
import { jobInfoDataSelector, jobInfoSelector } from 'features/jobs/selectors'
import { SpinnerCentered } from 'components/Loader'
import { commonMessages } from 'app/i18n/messages'

function HomeJobInfo() {
  const dispatch = useAppDispatch()
  const { formatMessage } = useIntl()
  const homeJob = useAppSelector(homeJobSelector.data)
  const isFetching = useAppSelector(jobInfoDataSelector.isFetching)
  const isFinished = useAppSelector(jobInfoDataSelector.isFinished)
  const isError = useAppSelector(jobInfoDataSelector.error)
  const jobInfo = useAppSelector(jobInfoSelector)

  useEffect(() => {
    if (homeJob?.id) {
      dispatch(fetchJobInfoThunk(homeJob.id))
    }

    return () => {
      dispatch(fetchJobInfoActions.clear())
    }
  }, [dispatch, homeJob?.id])

  return (
    <StyledFadeInWrapper>
      {isFetching && !isFinished && (
        <StyledJobHeader>
          <SpinnerCentered />
        </StyledJobHeader>
      )}
      {isError && (
        <StyledJobHeader>
          {formatMessage(commonMessages.commonError)}
        </StyledJobHeader>
      )}
      {isFinished && (
        <>
          {!jobInfo ? (
            <JobBlockContainer>
              {formatMessage(jobPageMessages.noJobFound)}
            </JobBlockContainer>
          ) : (
            <JobPageContext.Provider
              value={{
                jobName: jobInfo.name,
                jobId: jobInfo.id,
                parentDomainId: jobInfo.parentDomainId,
                hasHomes: !_isEmpty(jobInfo.homes),
              }}
            >
              <JobInfo hasHome={!_isEmpty(jobInfo.homes)} />
            </JobPageContext.Provider>
          )}
        </>
      )}
    </StyledFadeInWrapper>
  )
}

export default HomeJobInfo
